import { EMPTY_FIELD } from 'constants/emptyField';

import { Stack } from 'shared/mui/Stack/Stack';
import { Typography } from 'shared/mui/Typography';
import { FunctionField } from 'shared/react-admin/Fields';
import { Order } from 'types/embedded/order';
import { formatInputInTz } from 'utils/date';

export const OrdersShowCommonInfoStateDateTimeField = (): JSX.Element => {
  return (
    <FunctionField
      render={(record: Order) => {
        if (!record.updatedAt) {
          return EMPTY_FIELD;
        }
        const date = new Date(record.updatedAt);
        return (
          <Stack direction="row" gap="8px">
            <Typography variant="body2">{`${formatInputInTz(date, { format: 'dd.MM.yyyy' })}`}</Typography>
            <Typography variant="body2">
              {`${formatInputInTz(date, { format: 'HH:mm:ss' })}`}
            </Typography>
          </Stack>
        );
      }}
    />
  );
};
